import { Spin } from 'antd';
import { __CardProps } from './card.interface';
import { Link } from 'react-router-dom';
import { FaAngleLeft } from 'react-icons/fa';

const _Card = (props: __CardProps) => {
    return (
            <Spin spinning={props.loading ?? false} wrapperClassName={props.className}>
                <div
                    className={`w-full h-full ${props.noBottomPadding ? (props.size === 'small' ? 'pt-4' : 'pt-6') : (props.size === 'small' ? 'py-4' : 'py-6')} flex flex-col rounded-lg border border-primary-20 ${props.noPadding ? '' : 'gap-6'} overflow-hidden bg-white relative`}>
                    {props.title &&
                        <h2 className={`flex items-center justify-between ${props.size === 'small' ? 'px-4' : 'px-6'} font-bold ${props.size === 'small' ? 'text-base' : 'text-xl'} ${props.titleDivider ? 'border-b border-primary-20 pb-4' : 'pb-2'}`}>{props.title} {props.url && <Link to={props.url} className={"flex items-center justify-center w-6 h-6 hover:bg-primary-20 rounded transition duration-300 ease-in-out"}><FaAngleLeft size={16} className={'text-primary-100'} /></Link>}</h2>}
                    <div className={`${props.noPadding ? '' : props.size === 'small' ? 'px-4' : 'px-6'} h-full`}>
                        {props.children}
                    </div>
                </div>
            </Spin>
    );
};

export default _Card;
